module.exports = __webpack_public_path__ + "static/img/pointer.92d02f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/pointer.png
// module id = 2tfO
// module chunks = 1